import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgCircleProgressModule } from 'ng-circle-progress';

import { UPLOAD_PROGRESS } from '@components/upload-progress/upload-progress.constants';
import { CommonService } from '@shared/services/common.service';

@Component({
  selector: 'app-upload-progress',
  templateUrl: './upload-progress.component.html',
  styleUrls: ['./upload-progress.component.scss'],
  standalone: true,
  imports: [CommonModule, NgCircleProgressModule],
  host: {
    class: 'show-progress-bar pointer-none'
  }
})
export class UploadProgressComponent {
  @Input() percent = 0;

  readonly UPLOAD_PROGRESS = UPLOAD_PROGRESS;

  constructor(public readonly cs: CommonService) {}

  get outerStrokeColor(): string {
    return this.cs.isWhiteLabelWeb
      ? this.cs.whiteLabelData?.data?.whiteLabel?.theme_color
      : UPLOAD_PROGRESS.CIRCLE.DEFAULT_OUTER_STROKE;
  }
}
